import { z } from 'zod';

export const USER_SATISFACTION_REASONS = [
  'no_answer',
  'technical_problem',
  'poorly_written',
  'hard_to_use',
  'other',
] as const;

export type UserSatisfactionReason = (typeof USER_SATISFACTION_REASONS)[number];

export const OTHER_REASON: UserSatisfactionReason = 'other';

export const userSatisfactionFormSchema = z.object({
  reasons: z.array(z.enum(USER_SATISFACTION_REASONS)).min(1, 'Please select at least one reason'),
  additionalInfo: z.string().optional(),
  pageUrl: z.string().url(),
});

export type UserSatisfactionFormValues = z.infer<typeof userSatisfactionFormSchema>;
